import { Button } from '@mui/material'
import { useDrawersContext } from 'components/context/ClientsDrawersProvider'
import { useCallback, useMemo } from 'react'
import { useActions } from 'store/hooks'
import { ETimelinePostStatus, QuestionnaireTimelineItem } from 'types'
import { TimelineItemCard } from '../TimelineItemCard/TimelineItemCard'

const buttonTitleByStatus = {
  [ETimelinePostStatus.new]: 'Take',
  [ETimelinePostStatus.review]: 'Retake',
  [ETimelinePostStatus.retake]: 'Retake',
  [ETimelinePostStatus.done]: 'View',
}

interface Props {
  item: QuestionnaireTimelineItem
  disabled: boolean
}

export function TimelineExamItem({ item, disabled }: Props) {
  const { handleOpenQuestioning } = useDrawersContext()
  const { getTimelineById } = useActions()

  const onQuestioningTaken = useCallback(() => {
    getTimelineById({})
  }, [getTimelineById])

  const onClickQuestioning = () => {
    if (disabled) return

    handleOpenQuestioning({
      mode: 'take',
      id: item.questionnaireId,
      type: 'questionnaire',
      onQuestioningTaken: onQuestioningTaken,
    })
  }

  const buttonTitle = useMemo(() => buttonTitleByStatus[item.status], [item])

  return (
    <TimelineItemCard
      title={item.questionnaire.name}
      bannerUrl={item.questionnaire.bannerUrl}
      status={item.status}
      onClick={onClickQuestioning}
      controls={
        <Button size="small" variant="contained" onClick={onClickQuestioning} disabled={disabled}>
          {buttonTitle}
        </Button>
      }
    />
  )
}
